export const nav = {
    permission: 'ata.providers:ver',
    section: 'Settings',
    title: 'Providers',
    icon: 'smart_toy',
    route: '/providers',
    sequence: 14,
};

export default [
    {
        path: '/providers',
        name: 'providers',
        component: () => import('./pages/ProvidersPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.providers:ver' },
    },
];
